import type { RouteObject } from 'react-router-dom';
import { RoutingHomePage } from './pages/RoutingHomePage';
import { RoutingHelpPage } from './pages/RoutingHelpPage';
import { RoutingWorkInstructionsPage } from './pages/RoutingWorkInstructionsPage';

export const routingRoutes: RouteObject[] = [
  {
    path: 'routing',
    element: <RoutingHomePage />,
  },
  {
    path: 'routing/work-instructions',
    element: <RoutingWorkInstructionsPage />,
  },
  {
    path: 'help/routing',
    element: <RoutingHelpPage />,
  },
];
